export const initModalStep = () => {
    const btnRecommed = document.querySelector('.btn-modal__recommend');
    const wrapperModalSteps = document.querySelector('.wrapper-modal__steps');
    const modalSteps = wrapperModalSteps.querySelector('.modal__steps');
    const btnClose = modalSteps.querySelector('.modal-step__close');
    const inputsSteps = modalSteps.querySelectorAll('input[type="radio"]');
    const btnNext = modalSteps.querySelector('.button-step.step-next');
    const btnPrev = modalSteps.querySelector('.button-step.step-prev');
    const btnResult = modalSteps.querySelector('.button-step.step-result');
    const btnReset = modalSteps.querySelector('.button-step.step-reset');
    const totalElements = modalSteps.querySelectorAll('.step__questions');
    const wrapperResult = modalSteps.querySelector('.wrapper__results');
    const resultsItems = wrapperResult.querySelector('.results-items');
    const productsToCompare = [...wrapperResult.querySelectorAll('.products-to-compare .card-wrapper')];

    const currentElementStep = [...totalElements].find((element) => element.classList.contains('active'));
    const nextElementStep = currentElementStep.nextElementSibling;    

    let stateModal = {
        currentIdxStep: 0,
        totalElements: totalElements.length,
        prevElementStep: null,
        currentElementStep: currentElementStep,
        nextElementStep: nextElementStep
    }

    let stateDataModal = {};

    let swiperInitialize = true;

    const initSwiper = () => {

        const swiperCustom = new Swiper('.swiper-results__items', {
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                680: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    const validateSteps = (step) => {
        return stateDataModal[step] != undefined;
    }

    btnNext.addEventListener('click', () => {
        let { currentElementStep, nextElementStep, currentIdxStep} = stateModal;

        const nextStep = validateSteps(nextElementStep.dataset.step);

        if(!nextStep){
            btnNext.setAttribute('disabled', '');
        }

        currentElementStep.classList.remove('active');
        nextElementStep.classList.add('active');

        stateModal = {
            ...stateModal,
            currentIdxStep: currentIdxStep +1,
            prevElementStep: currentElementStep,
            currentElementStep: nextElementStep,
            nextElementStep: nextElementStep.nextElementSibling,
        }

        if(stateModal.currentIdxStep > 0){
            btnPrev.classList.remove('hidden');
        }

        if(stateModal.currentIdxStep === (stateModal.totalElements - 1)){
            btnNext.classList.add('hidden');
            btnPrev.classList.add('hidden');
            btnResult.classList.remove('hidden');   
        }


    });

    btnPrev.addEventListener('click', () => {
        let { currentElementStep, currentIdxStep, prevElementStep} = stateModal;

        const prevStep = validateSteps(prevElementStep.dataset.step);

        if(prevStep){
            btnNext.removeAttribute('disabled');
        }

        currentElementStep.classList.remove('active');
        prevElementStep.classList.add('active');

        stateModal = {
            ...stateModal,
            currentIdxStep: currentIdxStep - 1,
            nextElementStep: currentElementStep,
            currentElementStep: prevElementStep,
            prevElementStep: (currentIdxStep - 1) === 0 ? null : prevElementStep.previousElementSibling
        }

        if(stateModal.currentIdxStep == 0){
            btnPrev.classList.add('hidden');
        }
    })

    const getQty = (objTexts, objChoices) => {
        return objChoices.filter((choice) => objTexts.includes(choice)).length;
    }

    const setAttributeQty = async (listChoices) => {
        return new Promise((resolve, reject) => {
            productsToCompare.forEach((product, idx) => {
                const { quiz } = product.dataset;
                const listQuiz = quiz.split(',')
    
                const qty = getQty(listQuiz, listChoices);
                product.classList.add('swiper-slide');
                product.setAttribute('data-qty', qty);
                if(idx === (productsToCompare.length - 1)){
                    resolve(productsToCompare.sort((a, b) => {
                        return b.getAttribute('data-qty') - a.getAttribute('data-qty')
                    }).slice(0, 3))
                }
            })
        })
    }

    btnResult.addEventListener('click', async (e) => {
        e.preventDefault();
        const { currentElementStep } = stateModal;
        resultsItems.innerHTML = '';
        const resultsChoices = Object.entries(stateDataModal).map((([property, value]) => { return value}));

        await setAttributeQty(resultsChoices).then((bestProducts) => {
            bestProducts.forEach((bestProduct) => {
                resultsItems.appendChild(bestProduct);
            })
            if(swiperInitialize){
                initSwiper();
                swiperInitialize = false;
            }
            btnResult.classList.add('hidden');
            currentElementStep.classList.remove('active');
            wrapperResult.classList.remove('hidden');
            btnReset.classList.remove('hidden');
        })        
    });

    btnReset.addEventListener('click' , (e) => {
        e.preventDefault();

        stateModal = {
            ...stateModal,
            currentIdxStep: 0,
            prevElementStep: null,
            currentElementStep: totalElements[0],
            nextElementStep: totalElements[1]
        }

        totalElements.forEach((element, index) => {
            if (index === 0) {
                element.classList.add('active');
            } else {
                element.classList.remove('active');
            }
        });

        btnNext.classList.remove('hidden');
        btnPrev.classList.add('hidden');
        btnResult.classList.add('hidden');
        btnReset.classList.add('hidden');
        wrapperResult.classList.add('hidden');
    })


    btnRecommed.addEventListener('click', (e) => {
        e.preventDefault();
        wrapperModalSteps.classList.toggle('modal-hidden');
    });

    btnClose.addEventListener('click', (e) => {
        e.preventDefault();
        wrapperModalSteps.classList.add('modal-hidden');
    });

    inputsSteps.forEach((input) => {
        input.addEventListener('change', (e) => {
            const { value, name } = input;
            stateDataModal = {
                ...stateDataModal,
                [name]: value
            }

            btnNext.removeAttribute('disabled');
        });
    })
};